var _circle, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommercialLandloard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.7562,
    cy: 13.2396,
    r: 12.5,
    fill: "#9D51FE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1189_320",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 6,
    width: 15,
    height: 15
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.75623,
    y: 6.23962,
    width: 14,
    height: 14,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1189_320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.92285 18.4896V7.98962H12.7562V10.323H18.5895V18.4896H6.92285ZM8.08952 17.323H11.5895V16.1563H8.08952V17.323ZM8.08952 14.9896H11.5895V13.823H8.08952V14.9896ZM8.08952 12.6563H11.5895V11.4896H8.08952V12.6563ZM8.08952 10.323H11.5895V9.15629H8.08952V10.323ZM12.7562 17.323H17.4229V11.4896H12.7562V17.323ZM13.9229 13.823V12.6563H16.2562V13.823H13.9229ZM13.9229 16.1563V14.9896H16.2562V16.1563H13.9229Z",
    fill: "#FAF8FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommercialLandloard);
export default __webpack_public_path__ + "static/media/commercial_landloard.a87430b9f06edcaab1f1c64c8ba57eff.svg";
export { ForwardRef as ReactComponent };